// React Imports
import type { SVGAttributes } from 'react';

const RadioCircleMarked = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fontSize="1.5rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 5c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
      />
      <path fill="currentColor" d="M12 9c-1.627 0-3 1.373-3 3s1.373 3 3 3 3-1.373 3-3-1.373-3-3-3z" />
    </svg>
  );
};

export default RadioCircleMarked;
